<template>
  <v-dialog
    :key="key"
    v-model="dialog"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    width="300px"
    max-width="300px"
  >
    <template #activator="{ on, attrs }">
      <v-text-field
        v-model="selectedIcon"
        :prepend-icon="selectedIcon"
        outlined
        :label="$t('Select icon from built-in icons')"
        v-bind="attrs"
        readonly
        hide-details
        clearable
        v-on="on"
        @click:clear="clearIcon"
      />
    </template>
    <v-card style="overflow-x: scroll">
      <v-toolbar
        flat
        dark
        color="primary"
      >
        <v-text-field
          autofocus
          hide-details
          :placeholder="$t('Search icon')"
          prepend-icon="mdi-magnify"
          type="text"
          onautocomplete="off"
          @input="handleSearchInput"
        />
        <v-spacer />
        <v-btn
          icon
          dark
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-progress-linear
        :style="{'visibility': loading ? 'visible' : 'hidden'}"
        indeterminate
        color="primary"
      />

      <v-virtual-scroll
        :bench="0"
        :items="icons"
        height="300"
        item-height="40"
      >
        <template #default="{ item }">
          <v-row
            no-gutters
            class="flex-nowrap"
          >
            <v-col
              v-for="icon in item"
              :key="icon.id"
              cols="4"
              class="text-center"
            >
              <v-btn
                :title="icon.id"
                color="white"
                fab
                small
                depressed
                @click="selectIcon(icon)"
              >
                <v-icon
                  color="grey darken-3"
                  v-text="getIconClasses(icon)"
                />
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>
import debounce from 'lodash/debounce';
import chunk from 'lodash/chunk';
import axios from 'axios';

export default {
  props: {
    value: {
      type: String,
      required: false,
      default: null
    },
  },

  data() {
    return {
      key: 0,
      dialog: false,
      selectedIcon: this.value,
      icons: [],
      allIcons: [],
      searchQuery: '',
      searchResults: [],
      loading: false,
    }
  },

  watch: {
    'searchResults': function (searchResults) {
      if (this.searchQuery.length > 0) {
        searchResults = searchResults.map(icon => icon.id);
        const allIcons = JSON.parse(JSON.stringify(this.allIcons));
        const icons = allIcons.filter(icon => {
          return searchResults.indexOf(icon.id) !== -1;
        });

        this.setIcons(icons);
      } else {
        this.setIcons(this.allIcons);
      }
    },

    'value': function (value) {
      this.selectedIcon = value;
    }
  },

  async created() {
    const icons = await this.fetchIcons();
    this.setIcons(icons);
    this.allIcons = JSON.parse(JSON.stringify(icons));

    this.handleSearchInput = debounce(this.handleSearchInput, 300);
  },

  methods: {
    async fetchIcons() {
      const FONT_AWESOME_VERSION = this.$page.props.font_awesome_version;
      const res = await axios.post('https://api.fontawesome.com', {
        query: `query { release (version: "${FONT_AWESOME_VERSION}") { icons (license: "free") { id, label, styles } } }`
      }, { withCredentials: false });

      return res.data.data.release.icons;
    },

    async search(query) {
      const FONT_AWESOME_VERSION = this.$page.props.font_awesome_version;
      const res = await axios.post('https://api.fontawesome.com', {
        query: `query { search (version: "${FONT_AWESOME_VERSION}", query: "${query}", first: 5) { id, label, styles } }`,
      }, { withCredentials: false });

      return res.data.data.search;
    },

    async handleSearchInput(query) {
      this.searchQuery = query;

      if (this.searchQuery.length === 0) {
        this.$set(this, 'searchResults', []);
        return;
      }

      this.loading = true;
      const results = await this.search(this.searchQuery);

      this.$set(this, 'searchResults', results);
      this.loading = false;
    },

    setIcons(icons) {
      this.icons = chunk(icons, 3);
    },

    getIconClasses(icon) {
      const prefix = icon.styles.includes('brands') ? 'fab ' : 'fas ';
      return `${prefix}fa-${icon.id}`;
    },

    clearIcon() {
      this.selectedIcon = null;
      this.$emit('input', this.selectedIcon);
    },

    selectIcon(icon) {
      this.selectedIcon = this.getIconClasses(icon);
      this.dialog = false;
      this.$emit('input', this.selectedIcon);
    }
  }
}
</script>